import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog";
import { Spinner } from "../../../components/ui/spinner";
import type { MCPConnection } from "../types";
import { useTranslation } from "react-i18next";

type Props = {
  connection: MCPConnection | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const DeleteConnectionDialog = ({
  connection,
  isDeleting,
  onCancel,
  onConfirm,
}: Props) => {
  const { t } = useTranslation();
  const open = connection !== null;

  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next && !isDeleting) onCancel();
      }}
    >
      <AlertDialogContent className="border-border bg-card">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-foreground">
            {t("mcpPage.deleteDialog.title")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {connection
              ? t("mcpPage.deleteDialog.description", {
                  name:
                    connection.name.length > 50
                      ? `${connection.name.slice(0, 50)}...`
                      : connection.name,
                })
              : ""}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            className="border-border bg-card text-foreground hover:bg-accent"
            disabled={isDeleting}
          >
            {t("mcpPage.actions.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            aria-busy={isDeleting}
            className="bg-destructive text-white hover:bg-destructive/90"
          >
            {isDeleting ? (
              <>
                <Spinner className="size-4" />
                <span>{t("mcpPage.actions.deleting")}</span>
              </>
            ) : (
              t("mcpPage.actions.delete")
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteConnectionDialog;
